/* eslint-disable unicorn/filename-case */
import { createFileRoute } from '@tanstack/react-router';

import { TabActionPlan } from '../-tab-action-plan';
import type { ActionTaskStatus } from '../../../../entity/api/action-task';
import { addTrackCrumb } from '../../../../error/tracking';
import {
  useActionPlanByBrandId,
  useUpdateActionById,
} from '../../../../services/storage/seo-strategy-queries';

export const Route = createFileRoute('/app/_sidebar-layout/seo-strategy/$brandId/action-plan')({
  beforeLoad: function () {
    addTrackCrumb({
      category: 'route',
      message: '/app/_sidebar-layout/seo-strategy/$brandId/action-plan',
      level: 'info',
    });
  },
  // eslint-disable-next-line no-use-before-define
  component: SeoStrategyActionPlanTab,
});

function SeoStrategyActionPlanTab() {
  const { brandId } = Route.useParams();
  const { data, isLoading, isError } = useActionPlanByBrandId(brandId);
  const updateAction = useUpdateActionById();

  if (isLoading) {
    return (
      <div className="mx-auto w-full max-w-[800px] py-6 pb-12">
        <div className="flex flex-col gap-6">
          <div className="h-6 w-48 animate-pulse rounded bg-branding-gray-100" />
          <div className="h-10 w-full animate-pulse rounded bg-branding-gray-100" />
          <div className="grid grid-cols-2 gap-8">
            <div className="h-20 animate-pulse rounded-lg bg-branding-gray-100" />
            <div className="h-20 animate-pulse rounded-lg bg-branding-gray-100" />
          </div>
          <div className="h-64 animate-pulse rounded-lg bg-branding-gray-100" />
        </div>
      </div>
    );
  }

  if (isError || data == null) {
    return null;
  }

  function handleToggleTask(taskId: string, newStatus: ActionTaskStatus) {
    updateAction.mutate({ brandId, actionId: taskId, data: { status: newStatus } });
  }

  return (
    <div className="mx-auto w-full max-w-[800px] py-6 pb-12">
      <TabActionPlan
        tasks={data.list}
        numberOfTasksPerMonth={data.plan.tasksPerMonth}
        keywordFunnels={data.keywordFunnels}
        keywordUrls={data.keywordUrls}
        onToggleTask={handleToggleTask}
        startDate={data.plan.startDate}
      />
    </div>
  );
}
